import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trophy, MapPin, Wrench, Heart, Crown } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RANK_STYLES = [
  { bg: 'bg-[#FFB800]/10', border: 'border-[#FFB800]/30', badge: 'bg-[#FFB800] text-[#09090B]', icon: 'text-[#FFB800]' },
  { bg: 'bg-[#A1A1AA]/10', border: 'border-[#A1A1AA]/30', badge: 'bg-[#A1A1AA] text-[#09090B]', icon: 'text-[#A1A1AA]' },
  { bg: 'bg-[#CD7F32]/10', border: 'border-[#CD7F32]/30', badge: 'bg-[#CD7F32] text-[#09090B]', icon: 'text-[#CD7F32]' },
];

export default function TopArtisans() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/top-artisans`)
      .then(res => setData(res.data))
      .catch(err => console.error("Top artisans error:", err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading || !data || data.artisans.length === 0) return null;

  return (
    <section className="py-16 sm:py-20" data-testid="top-artisans-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#FFB800]/10 border border-[#FFB800]/30 rounded-full mb-4">
            <Trophy size={14} weight="fill" className="text-[#FFB800]" />
            <span className="text-xs font-bold text-[#FFB800] uppercase tracking-wider">Classement du mois</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-2 text-[#F4F4F5]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
            Top Artisans
          </h2>
          <p className="text-[#A1A1AA]">Les artisans les plus appréciés de {data.month}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {data.artisans.slice(0, 3).map((a) => {
            const style = RANK_STYLES[a.rank - 1] || RANK_STYLES[2];
            return (
              <div key={`top-${a.rank}-${a.user_name}`} className={`${style.bg} border ${style.border} rounded-lg p-5 text-center transition-all hover:scale-[1.02] animate-fade-in-up`}
                style={{ animationDelay: `${(a.rank - 1) * 0.1}s` }} data-testid={`top-artisan-${a.rank}`}>
                <div className={`w-10 h-10 ${style.badge} rounded-full font-black text-lg flex items-center justify-center mx-auto mb-3`} style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
                  {a.rank === 1 ? <Crown size={20} weight="fill" /> : a.rank}
                </div>
                <h3 className="font-bold text-lg text-[#F4F4F5] mb-1" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>{a.user_name}</h3>
                <div className="flex items-center justify-center gap-3 text-xs text-[#A1A1AA] mb-3">
                  {a.city && <span className="flex items-center gap-1"><MapPin size={12} weight="duotone" />{a.city}</span>}
                  {a.construction_type && <span className="flex items-center gap-1"><Wrench size={12} weight="duotone" />{a.construction_type}</span>}
                </div>
                <div className="flex items-center justify-center gap-4">
                  <div className="flex items-center gap-1">
                    <Heart size={16} weight="fill" className={style.icon} />
                    <span className="font-bold text-[#F4F4F5]">{a.total_likes}</span>
                    <span className="text-xs text-[#71717A]">likes</span>
                  </div>
                  <div className="text-xs text-[#71717A]">{a.posts_count} post{a.posts_count > 1 ? 's' : ''}</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Runners up */}
        {data.artisans.length > 3 && (
          <div className="mt-4 max-w-xl mx-auto space-y-2">
            {data.artisans.slice(3).map((a) => (
              <div key={`runner-${a.rank}-${a.user_name}`} className="flex items-center justify-between bg-[#18181B] border border-[#27272A] rounded-lg px-4 py-3">
                <div className="flex items-center gap-3">
                  <span className="w-7 h-7 rounded-full bg-[#27272A] text-[#A1A1AA] font-bold text-xs flex items-center justify-center">{a.rank}</span>
                  <span className="text-sm font-medium text-[#E4E4E7]">{a.user_name}</span>
                </div>
                <div className="flex items-center gap-1 text-sm">
                  <Heart size={14} weight="fill" className="text-[#8B5CF6]" />
                  <span className="text-[#F4F4F5] font-medium">{a.total_likes}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
